var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_login",
    "data-name": "vuesax/linear/login",
    transform: "translate(-684 -444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "login",
    transform: "translate(684 444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,10.562C.646,3.062,4.5,0,12.937,0h.271C22.521,0,26.25,3.729,26.25,13.042V26.625c0,9.313-3.729,13.042-13.042,13.042h-.271c-8.375,0-12.229-3.021-12.917-10.4",
    transform: "translate(18.542 5.187)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H26.833",
    transform: "translate(4.167 25)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0,6.979,6.979,0,13.958",
    transform: "translate(26.354 18.021)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H50V50H0Z",
    transform: "translate(50 50) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.6bf8d0839865ccb92af5086b9689f2bb.svg";
export { ForwardRef as ReactComponent };